// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Layout_Wrapper__8CxLD","DarkMode":"Layout_DarkMode__JbKSP","Body":"Layout_Body__5AsxH"};